
/**
 * 트윗 유형
 */
export type ExploreContentResponsePageAllOfThreeContentItemContentOneOfBasicInfoAllOfTwoTweetType = typeof ExploreContentResponsePageAllOfThreeContentItemContentOneOfBasicInfoAllOfTwoTweetType[keyof typeof ExploreContentResponsePageAllOfThreeContentItemContentOneOfBasicInfoAllOfTwoTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExploreContentResponsePageAllOfThreeContentItemContentOneOfBasicInfoAllOfTwoTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
  RETWEET: 'RETWEET',
} as const;
